import styles from './DownloadTemplate.module.scss';
import { MdsButton } from '@mds/react';
import { Link } from '@mds/web-ui-link';
import { Text } from '@mds/web-ui-text'
import { downloadTemplate } from '../../Service/FileDownloadService';
import type {ClpError} from '../../types/clpTypes';
import type { FC } from 'react';

interface DownloadTemplateProps {
  onErrors: (errors: ClpError[]) => void;
}

const DownloadTemplate: FC<DownloadTemplateProps> = ({ onErrors}) => {

  const handleErrors = (errors: ClpError[]) => {
    onErrors(errors);
  };

  const handleTemplateDownload = async (onError: (errors: ClpError[]) => void) => {
    console.log('Clearing errors');
    onError([]);

    try {
      console.log('Downloading template...');
      await downloadTemplate();
    } catch (error) {
      console.error('Error in handleTemplateDownload:', error);
      const err: ClpError = {type: 'system', message: '', subtype: 'download'};
      handleErrors([err]);
    }
  };

  return (
    <div className={styles.downloadTemplate}>

        <div className={styles['downloadTemplate-container']}>
          <div>
            <Text
              primitive="p"
              data-testid="mds-text-clp"
              textStyle="bodyMediumHeavier"
              >
            Upload a list of addresses to see if they&apos;re in qualifying census tracts. Properties must also meet other
            requirements.
            <br />
            To make sure your list uploads successfully, download and use our {' '}
              <Link
                data-testid="mds-link-1-clp"
                id="mds-link-click--cmb"
                href="#"
                textDecoration={['underline']}
                onClick={(e) => {
                  e.preventDefault();
                  handleTemplateDownload(handleErrors);
                }}
              >
                template
              </Link>. For more information, contact your Client Management Team.
            </Text>
          </div>
          <div className={styles['button-container']}>
            <MdsButton
              data-testid="mds-button-clp"
              id="mds-button-clp"
              text="Download template"
              variant="primary"
              inverse
              widthType="content"
              small
              type="button"
              disableLiveRegion={false}
              inactive={false}
              accessibleText="Download template"
              tabFocusable
              isLoading={false}
              iconType="ico_download"
              iconPosition="leading"
              onClick={(e) => {e.preventDefault(); handleTemplateDownload(handleErrors);}}
            >
            </MdsButton>
          </div>
        </div>
    </div>
  );
};
export default DownloadTemplate;
